import defaultTheme from '../../styles/themes/default';

export const selectStyle = {
  indicatorSeparator: (styles: any) => ({
    ...styles,
    display: 'none',
    border: 'none',
  }),
  control: (styles: any, { isFocused }: any) => ({
    ...styles,
    backgroundColor: defaultTheme.colors.white,
    width: '100%',
    height: '48px',
    boxShadow: isFocused ? '0 0 0 3px rgba(245, 128, 37, 0.15)' : 'none',
    outline: 'none',
    border: '1px solid',
    borderColor: isFocused
      ? defaultTheme.colors.orange.primary
      : defaultTheme.colors.gray[400],
    borderRadius: '8px',
    color: defaultTheme.colors.gray[400],
    padding: '0',
    '&:hover': {
      borderColor: defaultTheme.colors.orange.primary,
    },
    maxHeight: '48px',
    cursor: 'pointer',
  }),
  valueContainer: (styles: any) => ({
    ...styles,
    margin: '0 16px',
  }),
  placeholder: (styles: any) => ({
    ...styles,
    fontSize: '14px',
    fontFamily: 'Poppins',
    // margin: '0 16px',
    fontWeight: 300,
    color: defaultTheme.colors.gray[500],
    whiteSpace: 'nowrap',
  }),
  option: (styles: any, { isFocused, isSelected }: any) => ({
    ...styles,
    backgroundColor: isSelected
      ? defaultTheme.colors.orange.primary
      : isFocused
        ? defaultTheme.colors.gray[100]
        : defaultTheme.colors.white,
    color: isSelected
      ? defaultTheme.colors.white
      : isFocused
        ? defaultTheme.colors.gray[900]
        : defaultTheme.colors.gray[400],
    fontSize: '14px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    cursor: 'pointer',
  }),
  singleValue: (styles: any) => ({
    ...styles,
    color: defaultTheme.colors.gray[500],
    fontSize: '14px',
    fontWeight: 700,
    whiteSpace: 'nowrap',
  }),
  menu: (styles: any) => ({
    ...styles,
    color: defaultTheme.colors.gray[600],
    fontSize: '14px',
    fontWeight: 700,
    whiteSpace: 'nowrap',
  }),
  menuPortal: (styles: any) => ({
    ...styles,
    zIndex: 9999,
  }),
};
